import { Box, Typography } from "@mui/material";
import { AD_ACCOUNT_OPTIONS_DISPLAY_NAMES } from "../../../../../../utils/constants";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const MicrosoftActiveDirectoryServiceUserDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {entityData?.microsoft_active_directory_service_user_data
        ?.ad_user_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Username</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.microsoft_active_directory_service_user_data
                  ?.ad_user_name
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_service_user_data
        ?.organizational_unit && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight={"500"}>
              Organizational Unit
            </Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.microsoft_active_directory_service_user_data
                  ?.organizational_unit
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_service_user_data
        ?.user_account_control_flags?.length > 0 && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" gap={1} alignItems="center">
            <Typography variant="subtitle2">AD Account Options</Typography>
          </Box>
          <Box display="flex" flexDirection="column" gap={1} ml={2}>
            {entityData.microsoft_active_directory_service_user_data.user_account_control_flags.map(
              (flag) => (
                <TextIntegrationStyle
                  key={flag}
                  title={""}
                  value={AD_ACCOUNT_OPTIONS_DISPLAY_NAMES[flag] || flag}
                />
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_service_user_data
        ?.logon_workstation && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Logon Workstation</Typography>
          </Box>
          <Box ml={2}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData?.microsoft_active_directory_service_user_data
                  ?.logon_workstation
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_service_user_data
        ?.allowed_to_delegate_to?.length > 0 && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>
              Constrained Delegation Service
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={2}>
            {entityData.microsoft_active_directory_service_user_data.allowed_to_delegate_to.map(
              (item, idx) => (
                <TextIntegrationStyle key={idx} title={""} value={item} />
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_service_user_data
        ?.service_principal_names?.length > 0 && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>
              Service Principal Name
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={2}>
            {entityData.microsoft_active_directory_service_user_data.service_principal_names.map(
              (item, idx) => (
                <TextIntegrationStyle key={idx} title={""} value={item} />
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_service_user_data?.type && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Type</Typography>
          </Box>
          <Box ml={2}>
            <TextIntegrationStyle
              title={""}
              value={
                entityData.microsoft_active_directory_service_user_data.type
              }
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MicrosoftActiveDirectoryServiceUserDetailsView;
